import React, { useEffect, useState } from 'react';
import useDebounce from '../hooks/useDebounce';
import useUpdateEffect from '../hooks/useUpdateEffect';
import { updateData } from '../utils/filterHelperFunctions';
import { RiFilter3Fill } from 'react-icons/ri';
import { RxCross2 } from 'react-icons/rx';
import { mls } from 'lib/multilanguagesupport';
import Slider from '@mui/material/Slider';
import { AiFillInfoCircle } from 'react-icons/ai';
import { numberConditionData } from '../data/defaultFilterSchema';
import ObjectDropDown from 'lib/reusable-components/Components/DropDowns/ObjectDropDown';

interface filterItemsNUMProps {
  elem: any;
  selectedColumns: any[];
  index: number;
  setSelectedColumns: (columns: any[]) => void;
  handleRemoveColumnSelection: (elem: any) => void;
}
const FilterItemsNUM = ({
  elem,
  selectedColumns,
  index,
  setSelectedColumns,
  handleRemoveColumnSelection,
}: filterItemsNUMProps) => {
  const [filterValueNUM, setFilterValueNUM] = React.useState([
    elem?.value?.min ?? elem.filterData.range.min,
    elem?.value?.max ?? elem.filterData.range.max,
  ]);
  const [conditionData, setConditionData] = useState(
    elem?.value?.condition ?? numberConditionData.inRange.key
  );
  const [numberValue, setNumberValue] = useState(elem?.value?.value ?? 0);
  const debounceValue = useDebounce(filterValueNUM);
  const isRangeTypeCondition = conditionData === numberConditionData.inRange.key;
  const handleChange = (event: any, newValue: any) => {
    setFilterValueNUM(newValue);
  };
  const handleConditon = (action: any) => {
    setFilterValueNUM([0, 0]);
    setNumberValue(0);
    setConditionData(action);
  };
  useUpdateEffect(() => {
    // const value = {
    //   min: filterValueNUM[0],
    //   max: filterValueNUM[1],
    // };
    // const getData = updateData(selectedColumns, index, value);
    // setSelectedColumns(getData);

    const isRangeTypeCondition = conditionData === numberConditionData.inRange.key;
    let value = {};

    if (isRangeTypeCondition) {
      value = {
        min: filterValueNUM[0],
        max: filterValueNUM[1],
        condition: conditionData,
      };
    } else {
      value = {
        value: numberValue,
        condition: conditionData,
      };
    }
    console.log('value', value);

    const getData = updateData(selectedColumns, index, value);
    setSelectedColumns(getData);
  }, [debounceValue, conditionData, numberValue]);

  const isNotCorrect = filterValueNUM[0] > filterValueNUM[1];
  const errorMsg = mls('Max must be  greater than Min');
  const handleColumnValue = (e: any) => {
    setNumberValue(Number(e.target.value ?? ''));
  };

  useEffect(() => {
    setFilterValueNUM([
      elem?.value?.min ?? elem?.filterData?.range?.min,
      elem?.value?.max ?? elem?.filterData?.range?.max,
    ]);
    setConditionData(elem?.value?.condition ?? numberConditionData.inRange.key);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [`${elem?.columnName}.${elem?.tableName}`]);
  return (
    <div className='containerItems'>
      <div className='Title'>
        <div className='filterIcon'>
          <RiFilter3Fill />
        </div>
        <div className='titleName'>{elem.name}</div>
        <div className='removeFilter' onClick={() => handleRemoveColumnSelection(elem)}>
          <RxCross2 />
        </div>
      </div>
      <div className='titleDiv'>{mls('Condition')}</div>
      <ObjectDropDown
        object={numberConditionData}
        dropDownValue={conditionData ?? numberConditionData.inRange.key}
        setdropDownValue={handleConditon}
        ObjectInObject
      />
      <>
        {isRangeTypeCondition ? (
          <>
            <div className='sliderDiv'>
              {elem?.filterData?.range?.min === elem?.filterData?.range?.max ? (
                <Slider
                  value={filterValueNUM}
                  sx={{
                    color: isNotCorrect ? 'red' : '',
                  }}
                  min={elem?.filterData?.range?.min}
                  max={elem?.filterData?.range?.max}
                  onChange={() => {}}
                  valueLabelDisplay='off'
                />
              ) : (
                <>
                  <Slider
                    value={filterValueNUM}
                    sx={{
                      color: isNotCorrect ? 'red' : '',
                    }}
                    min={elem?.filterData?.range?.min ?? 0}
                    max={elem?.filterData?.range?.max ?? 0}
                    onChange={handleChange}
                    valueLabelDisplay='off'
                  />
                </>
              )}
            </div>
            <div className='numberInputDivContainer'>
              <div className='leftNumberInputDiv innerNumberInputDiv'>
                <div className='titleDiv'>{mls('Min')}:</div>
                <input
                  type='number'
                  className='primaryInput'
                  value={filterValueNUM[0]}
                  onChange={(e) => handleChange(e, [Number(e.target.value), filterValueNUM[1]])}
                />
              </div>
              <div className='rightNumberInputDiv innerNumberInputDiv'>
                <div className='titleDiv'>{mls('Max')}:</div>
                <input
                  type='number'
                  className='primaryInput'
                  style={isNotCorrect ? { background: '#ffc1c1' } : {}}
                  value={filterValueNUM[1]}
                  onChange={(e) => handleChange(e, [filterValueNUM[0], Number(e.target.value)])}
                  title={isNotCorrect ? errorMsg : ''}
                />
                {isNotCorrect ? (
                  <div className='errorInfo' title={errorMsg}>
                    <AiFillInfoCircle />
                  </div>
                ) : null}
              </div>
            </div>
          </>
        ) : (
          <>
            <div className='titleDiv'>{mls('Value')}</div>
            <input
              className='primaryInput'
              type='number'
              placeholder={mls('Select')}
              value={numberValue ?? ''}
              onChange={(e) => handleColumnValue(e)}
            />
          </>
        )}
      </>
      {isNotCorrect ? <div className='errorDisplay'></div> : null}
    </div>
  );
};
export default FilterItemsNUM;
